// / <reference path="./I18nLEagueRiver.d.ts" />

import React from 'react';
import 'isomorphic-fetch';
import logEvent from '~/util/analytics';

import StyledComponent from '~/components/Styled/Styled';
import ScoreTicker from '~/containers/ScoreTickerContainer';

import Ad, { AdTypes } from '~/containers/AdContainer/AdContainer';
import FacebookPageBox from '~/components/FacebookPageBox/FacebookPageBox';

import masonry from '~/static/css/masonry.css';
import css from './I18nLeagueRiver.scss';

type Props = {
  league: {
    slug: string;
    short_name: string;
    medium_name: string;
    sections: Object[];
  };
  showFacebookPagePlugin: boolean;
  children?: React.ReactNode;
};

class I18nLeagueRiver extends React.Component<Props> {
  static defaultProps = {
    children: null,
    showFacebookPagePlugin: false,
  };

  static displayName = 'I18nLeagueRiver';

  render() {
    const { league, showFacebookPagePlugin, children } = this.props;
    return (
      <div>
        <div className={css.wrapAdContainer}>
          <Ad leagueSlug={league.slug} adType={AdTypes.WRAP} />
        </div>
        <div className={css.adContainer}>
          <Ad leagueSlug={league.slug} adType={AdTypes.LEADERBOARD} />
        </div>
        <div className={css.riverContainer}>
          <div className={masonry.gridSizer} />
          <div className={masonry.gridGutter} />
          <div className={css.ticker}>
            <div className={`${masonry.gridItem} ${masonry.gridItemFullWidth}`}>
              <ScoreTicker trackEvent={logEvent} height="76px" leagueSlug={league.slug} />
            </div>
          </div>
          <div className={`${masonry.gridItem} ${masonry.gridItemFullWidth}`}>{children}</div>
          <div className={`${css.facebookPageBox} col-sm-6 col-md-12`}>
            {showFacebookPagePlugin && <FacebookPageBox />}
          </div>
        </div>
      </div>
    );
  }
}

export default StyledComponent(I18nLeagueRiver, [css, masonry]);
